import type { FunctionComponent, PropsWithChildren } from 'react';
import {
  Card,
  paletteHelper,
  spacingHelper,
  Text,
  typographyHelper,
} from '@property.com.au/ui-kit';
import styled from 'styled-components';

const StyledBox = styled(Card)`
  display: flex;
  flex-direction: column;
  max-width: 204px;
  text-align: center;
  overflow: hidden;
`;

const HeaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${paletteHelper('backgroundSecondaryBase')};
  padding: ${spacingHelper('medium extraLarge')};
`;

const HeaderText = styled(Text)`
  ${typographyHelper('overline')};
`;

const BodyContainer = styled.div`
  background-color: ${paletteHelper('backgroundPrimaryHigh')};
`;

interface GraphTooltipProps {
  label: string;
}

export const GraphTooltip: FunctionComponent<PropsWithChildren<GraphTooltipProps>> = ({
  label,
  children,
}) => (
  <StyledBox>
    <HeaderContainer>
      <HeaderText variant="caption">{label}</HeaderText>
    </HeaderContainer>
    <BodyContainer>{children}</BodyContainer>
  </StyledBox>
);
